//IMPORTS
import NavBar from "./navBar";
import pdfLibrary from "./pdfLibrary";

export const pods = {
    navBar: NavBar,
    pdfLibrary: pdfLibrary
};
